<template>
    <slot
        :show-header="showHeader"
        :activeSubnode="activeSubnode"
        :activeMenu="activeMenu"
        :setActiveMenu="setActiveMenu"
        :setActiveSubnode="setActiveSubnode"
    >
    </slot>
</template>

<script setup>
import { useRafFn, useWindowScroll } from '@vueuse/core';
import { onMounted, ref } from 'vue';

const props = defineProps({
    threshold: {
        type: Number,
        default: 320,
    },
});

const showHeader = ref(false);
const activeSubnode = ref(null);
const activeMenu = ref(null);

const setActiveMenu = (menuId) => {
    activeMenu.value = menuId;
};

const setActiveSubnode = (subnodeId) => {
    activeSubnode.value = subnodeId;
};

const initialScrollPos = ref(0);

const { y: scrollYPos } = useWindowScroll();

onMounted(() => {
    initialScrollPos.value = scrollYPos.value;
});

useRafFn(() => {
    if (scrollYPos.value === initialScrollPos.value) {
        return;
    }

    if (scrollYPos.value > props.threshold) {
        // AuthenticatorResponse.value = false;
        showHeader.value = true;
    } else {
        showHeader.value = false;
    }
});

</script>
